module.exports = __webpack_public_path__ + "CraftsByMelon.webp?1783354b1deeab15a3c37d3bf06345e4";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CraftsByMelon.webp
// module id = 65
// module chunks = 0